import React, {useEffect, useState} from 'react';
import { useAuth } from '../Auth';
import {   
    Button,
    Grid,
} from '@material-ui/core';
// import { v4 as uuidv4 } from 'uuid';
// const arrMeses = ['','Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

const TraktecomInventario = () =>{
    //const [ data2, setData2] = useState(false);
    const [ isContinuo, setContinuo ] = useState(false);
    // const [ data, setData ] = useState([]);
    // const [ dataBackup, setDataBackup ] = useState([]);
    // const [ rows, setRows] = useState([]);
    const { authTokens } = useAuth();

    useEffect(()=>{
        const handleSelectZona = async (valZ)=>{
            // const dataZonas = await fetch('/api/zonas');
            // const resultZonas = await dataZonas.json();
            // const dataCli = await fetch(`/api/ClientesbyEmpresa/${authTokens.Empresa}`);
            // const resultCli = await dataCli.json();
            // const filCli = resultCli.filter(el=>el.Zona.toString() === 'Mapasingue Oeste')
            // setData(resultCli)
            // setDataBackup(resultCli);
            
        }
        handleSelectZona();
    },[]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(isContinuo){
            setContinuo(false);
            (async ()=>{
                const gotoUpdate = await fetch(`/clientes/update/${authTokens.Empresa}`);
                const jsonUpdate = await gotoUpdate.json();
                if(jsonUpdate.message){ 
                    alert(jsonUpdate.error)
                    return;
                }
                    alert(jsonUpdate.message)
            })();

           
        }

    },[isContinuo]) // eslint-disable-line react-hooks/exhaustive-deps


    const handleProcesar2 = ()=>{
        // fetch('/api/recibos/modificarRecibos',{
        //     method:'POST',
        //     body: JSON.stringify({AddressIp:'10.15.10.9'}),
        //     headers:{
        //         'Content-Type': 'application/json'
        //     }
        // }) 
        // .then(response=> response.json())
        // .then(result =>{
        //     alert(result.message)
        //     console.log(result)
        // }); 
        // const arr = [];
        // let indx = 0;
        // // let indexServ = 0
        // for(const x in data){
        //     indx++;
        //     const objeto = {...data[x]};
        //     // objeto.Empresa = "INTERCOM";
        //     // objeto.ageWork = parseInt(data[x].Registro.split('-')[0]);
        //     const arrServ = [];
        //     let index = 0;
        //     for(const y in objeto.Servicios){
        //         index ++;
        //         // indexServ++;
        //         const objetoSer = {...objeto.Servicios[y]};   
        //         objetoSer.TipoCuenta = 'Residencial';
        //         arrServ.push(objetoSer);
        //         if(index === (objeto.Servicios.length)){
        //             objeto.Servicios = arrServ;
        //             arr.push(objeto);
        //         }
        //     }
        //     if(indx === data.length) {
        //         setRows(arr);
        //         setTimeout(()=>{
        //             setContinuo(true);
        //         },500)
        //     };
        
        // }

            setContinuo(true);

    };

    // const handlePeticion = ()=>{
    //     fetch('/api/pingOnu',{
    //         method:'POST',
    //         body: JSON.stringify({AddressIp:'10.15.10.9'}),
    //         headers:{
    //             'Content-Type': 'application/json'
    //         }
    //     }) 
    //     .then(response=> response.json())
    //     .then(result =>{
    //         console.log(result)
    //     }); 
    // };


    return(
        <Grid container justifyContent='center' spacing={2} style={{width:'90%', border:'1px solid lightgray', borderRadius:5, height:'85vh'}}>
            <Grid item xs={5} style={{alignSelf:'center'}}>

                <Button color='primary' onClick={handleProcesar2} variant='contained' fullWidth>
                    PROCESARFETCH
                </Button>
            </Grid>
            <Grid item xs={5} style={{alignSelf:'center'}}>
                {/* <p>{rows.length}</p> */}
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={8} xs={12}>
                            
                            </Grid>
        </Grid>
    );
};

export default TraktecomInventario;